import styled, { css } from 'styled-components';
import {
  Button as StormButton,
  Flex,
  isMobileStyleMixin,
  Menu,
  MenuButtonTrigger,
  MenuItemGroup,
  MenuItemLink,
  styleMixinFocusOutline,
  TextButton as StormTextButton,
} from '@amzn/storm-ui';

export const InfoText = styled.span`
  font-size: 13px;
  color: #767676;
`;

export const SpinnerWrap = styled.span`
  margin-inline-end: ${({ theme }) => theme.spacing.xxxsmall.default};
`;

export const ActionsWrapper = styled(Flex)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)};
`;

export const ActionButtonsWrap = styled(Flex)`
  ${isMobileStyleMixin(css`
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  `)};
`;

export const ActionDropdownTrigger = styled(MenuButtonTrigger)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)};

  & span {
    width: inherit;
  }
`;

export const ActionItemWrap = styled.span`
  ${isMobileStyleMixin(css`
    margin: 0;
    width: 100%;
  `)};
`;

export const ActionLinkItemWrap = styled(ActionItemWrap)`
  margin-left: 7px;
`;

export const Button = styled(StormButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const TextButton = styled(StormTextButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const StyledMenu = styled(Menu)`
  & li {
    list-style: none;
  }
`;

export const StyledMenuItemGroup = styled(MenuItemGroup)`
  & ul {
    margin: 0;
  }
`;

export const StyledMenuItemLink = styled(MenuItemLink)`
  :hover {
    text-decoration: none;
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    ${styleMixinFocusOutline};
  }
`;
